import { atom } from "jotai";

import { getUserData, isAuthenticated } from "@shared/api/lib/auth/auth";

export const userAtom = atom(isAuthenticated() ? getUserData() : undefined);
export const userIdAtom = atom((get) => get(userAtom)?.user_id);
